import { render, staticRenderFns } from "./forgot.vue?vue&type=template&id=81c91b84"
import script from "./forgot.vue?vue&type=script&lang=js"
export * from "./forgot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81c91b84')) {
      api.createRecord('81c91b84', component.options)
    } else {
      api.reload('81c91b84', component.options)
    }
    module.hot.accept("./forgot.vue?vue&type=template&id=81c91b84", function () {
      api.rerender('81c91b84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/forgot.vue"
export default component.exports